import cityShowcaseApi from '../_api';
import CityShowcase from '@/models/CityShowcase';

export default {
  namespaced: true,

  state: {
    storesOptions: [],
    cityShowcases: [],
    loadingStores: false,
    loadingCityShowcases: false,
  },

  getters: {
    storesOptions: (state,) => state.storesOptions,
    loadingStores: (state,) => state.loadingStores,
    cityShowcases: (state,) => state.cityShowcases,
    loadingCityShowcases: (state,) => state.loadingCityShowcases,
  },

  mutations: {
    setStoresOptions: (state, storesOptions,) => {
      state.storesOptions = storesOptions;
      state.stores = storesOptions;
    },
    setLoadingStores: (state, loading,) => {
      state.loadingStores = loading;
    },
    setCityShowcases: (state, cityShowcases,) => {
      state.cityShowcases = cityShowcases;
    },
    setLoadingCityShowcases: (state, loading,) => {
      state.loadingCityShowcases = loading;
    },
  },

  actions: {
    setStoresOptions ({ commit, }, storesOptions = [],) {
      commit('cityShowcase/setStoresOptions', storesOptions, { root: true, },);

      return storesOptions;
    },

    async getCityShowcasesByCity (
      { commit, },
      { franchiseId, cityId, enabled, } = {},) {

      commit('cityShowcase/setLoadingCityShowcases', true, { root: true, },);

      try {
        const response = await cityShowcaseApi.getStoreGridsByCity(
          franchiseId,
          { enabled, city_id: cityId, },
        );

        const items = response?.data?.items;

        const cityShowcases = items?.length > 0 ? items: [];

        const normalizedCityShowcases = cityShowcases.map(
          (showcase,) => new CityShowcase(showcase,),
        );

        commit('cityShowcase/setCityShowcases', normalizedCityShowcases, { root: true, },);

        return normalizedCityShowcases;
      } catch (error) {
        commit('cityShowcase/setCityShowcases', [], { root: true, },);
        return cityShowcaseApi.handleError(error,);
      } finally {
        commit('cityShowcase/setLoadingCityShowcases', false, { root: true, },);
      }
    },

    async createStoreGrid (_, { name, city, stores, },) {
      const state = city.name.split('-',).at(-1,).trim();

      const payload = {
        name,
        address: {
          city: city.name,
          state,
          city_id: Number(city.city_id,),
        },
        stores: stores.map((store, index,) => ({
          company_uuid: store.company_uuid,
          position: index + 1,
        }),),
      };

      return cityShowcaseApi.createStoreGrid(city.id, payload,);
    },

    async updateStoreGrid (_, { id, name, city, stores, },) {
      const state = city.name.split('-',).at(-1,).trim();

      const payload = {
        name,
        address: {
          city: city.name,
          state,
          city_id: Number(city.city_id,),
        },
        stores: stores.map((store, index,) => ({
          company_uuid: store.company_uuid,
          position: index + 1,
        }),),
      };

      return cityShowcaseApi.updateStoreGrid(city.id, id, payload,);
    },

    async updateStoreGridEnabled (_, { franchiseId, storeGridId, enabled, },) {
      return cityShowcaseApi.updateStoreGridEnabled(
        franchiseId,
        storeGridId,
        { enabled, },
      );
    },

    async deleteStoreGrid (_, { franchiseId, storeGridId, },) {
      try {
        return await cityShowcaseApi.deleteStoreGrid(franchiseId, storeGridId,);
      } catch (error) {
        if (error.response?.data?.errors?.length) {
          return Promise.reject(error.response.data.errors[0],);
        }

        return Promise.reject(error,);
      }
    },
  },
};
